import React, { useLayoutEffect, useRef } from 'react'
import * as am5 from '@amcharts/amcharts5'
import * as am5percent from '@amcharts/amcharts5/percent'
import { useTranslation } from 'react-i18next'
import { localizationAMChart } from '../../utils/AMChartsSettings'
import { useGlobalStoreData } from '../../store/globalStore'
import { LANGUAGES } from '../../utils/Utils'

const SimplePieChart = ({ chartId, data }) => {
  const { t } = useTranslation()
  const rootRef = useRef(null)
  const languageGSD = useGlobalStoreData.language()

  useLayoutEffect(() => {
    const root = am5.Root.new(chartId)
    localizationAMChart(root)

    const chart = root.container.children.push(
      am5percent.PieChart.new(root, {
        layout: root.verticalLayout
      })
    )

    const series = chart.series.push(
      am5percent.PieSeries.new(root, {
        valueField: 'value',
        categoryField: 'name',
        calculateAggregates: true
      })
    )

    series.labels.template.setAll({
      forceHidden: true
    })

    series.ticks.template.setAll({
      visible: false
    })

    series.slices.template.setAll({
      toggleKey: null,
      tooltipText: '{name}: {value}'
    })

    series.data.setAll([
      { name: t('limit.used'), value: data.used < 0 ? 0 : data.used },
      { name: t('limit.remaining'), value: data.total - data.used < 0 ? 0 : data.total - data.used }
    ])

    const legend = chart.children.push(
      am5.Legend.new(root, {
        centerX: am5.percent(50),
        x: am5.percent(50),
        layout: root.verticalLayout
      })
    )

    legend.itemContainers.template.setAll({
      reverseChildren: languageGSD === LANGUAGES.ARABIC
    })

    legend.data.setAll(series.dataItems)

    rootRef.current = root

    return () => {
      root.dispose()
    }
  }, [chartId, data])

  return <div id={chartId} style={{ width: '100%', height: '200px', pointerEvents: 'none' }}></div>
}

export default SimplePieChart
